export enum View {
    ADD_CARD,
    CARDS_ON_FILE,
}
